import { createReducer, on } from '@ngrx/store';
import { CustomerInfo, PurchasesOfferings, PurchasesPackage } from '@revenuecat/purchases-capacitor';
import * as RevenueCatActions from './actions';

export const stateName = 'revenuecat';

export interface State {
  packages: PurchasesPackage[];
  offerings: PurchasesOfferings | null;
  customerInfo: CustomerInfo | null;
  loginItem: any | null;
  loading: boolean;
  error: any;
}

export const initialState: State = {
  packages: [],
  offerings: null,
  customerInfo: null,
  loginItem: null,
  loading: false,
  error: null
};

export const reducer = createReducer(
  initialState,
  on(RevenueCatActions.configure, (state) => ({ ...state, loading: true })),
  on(RevenueCatActions.loadPackages, (state) => ({ ...state, loading: true, error: null })),
  on(RevenueCatActions.loadPackagesSuccess, (state, { offerings }) => ({
    ...state,
    offerings,
    packages: offerings.current?.availablePackages || [],
    loading: false
  })),
  on(RevenueCatActions.loadPackagesFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(RevenueCatActions.purchasePackage, (state) => ({ ...state, loading: true, error: null })),
  on(RevenueCatActions.purchasePackageSuccess, (state, { customerInfo }) => ({ ...state, customerInfo, loading: false })),
  on(RevenueCatActions.purchasePackageFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(RevenueCatActions.restorePurchases, (state) => ({ ...state, loading: true, error: null })),
  on(RevenueCatActions.restorePurchasesSuccess, (state, { customerInfo }) => ({ ...state, customerInfo, loading: false })),
  on(RevenueCatActions.restorePurchasesFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(RevenueCatActions.checkSubscriptionStatus, (state) => ({ ...state, loading: true, error: null })),
  on(RevenueCatActions.checkSubscriptionStatusSuccess, (state, { customerInfo }) => ({ ...state, customerInfo, loading: false })),
  on(RevenueCatActions.checkSubscriptionStatusFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(RevenueCatActions.updateCustomerInfo, (state, { customerInfo }) => ({ ...state, customerInfo })),
  on(RevenueCatActions.updateLoginItem, (state, { loginItem }) => ({ ...state, loginItem }))







);
